import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  Stack
} from '@mui/material';
import { getTableUserSettings } from '../services/setting.service';
import { useInfoStore } from '../store/userInfo';
import { toast } from 'react-toastify';
import { checkRequest } from '../services/order.service';
import { logger } from '../utils/logger';

interface DiningTimeEndedDialogProps {
  open: boolean;
  onClose: () => void;
  onAskForCheck: () => void;
}

const DiningTimeEndedDialog: React.FC<DiningTimeEndedDialogProps> = ({
  open,
  onClose,
  onAskForCheck
}) => {
  const { userInfo, tableInfo } = useInfoStore();
  const storeId = userInfo?.storeId
  const [publicSettings, setPublicSettings] = useState<any>(null)

  useEffect(() => {
    if(storeId)
    loadPublicSettings()
    // requestCheck()
  }, [storeId])

  // const requestCheck = async () => {
  //   await checkRequest(tableInfo?.id).then(
  //     (res) => {
  //       if(res.status === 200) {

  //       }
  //     }
  //   )
  // }
  const loadPublicSettings = async () => {
    if(!storeId) return;
    const res = await getTableUserSettings(storeId)
    if(res.status === 200) {
      logger.debug('publicSettings', res.data)
      setPublicSettings(res.data)
    }
  }

  const handleOK = () => {
    // if(publicSettings?.useCheck) {
    //   onAskForCheck()
    // } else {
    //   toast.success('Thank you for your waiting!')
    // }
    // 항상 onClose() 호출하여 프로모션 상태 초기화
    onClose()
  }
  return (
    <Dialog 
      open={open} 
      maxWidth="xs" 
      fullWidth 
      sx={{backgroundColor: 'rgba(0, 0, 0, 0.5)'}}
      PaperProps={{
        sx: {
          borderRadius: '1.6rem',
          overflow: 'hidden',
          width: '42.3rem',
        }
      }}
    >
      <DialogContent sx={{ 
        textAlign: 'center', 
        p: '4.0rem', 
        gap: '3.2rem', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
      }}>
        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
            <img 
                src={process.env.PUBLIC_URL+'/assets/images/smile.svg'} 
                alt="smile" 
                style={{ width: '8.0rem', height: '8.0rem' }}
            />

            <Typography gutterBottom sx={{color: '#111', fontSize: '2.4rem', fontWeight: '600', lineHeight: '2.8rem', mt: '2.0rem', textWrap: 'nowrap'}}>
                Your dining time has ended.
            </Typography>

            <Typography sx={{color: '#555', fontSize: '1.6rem', fontWeight: '500', lineHeight: '2.0rem', mt: '.8rem'}}>
                We hope you enjoyed your meal! <br />
                Please call a server when you're ready to pay.
            </Typography>
        </Box>

        <Button
          variant="contained"
          onClick={handleOK}
          sx={{
            backgroundColor: '#F72E13',
            '&:hover': { backgroundColor: '#d62811' },
            color: '#fff',
            px: '4.0rem', 
            fontWeight: 600,
            fontSize: '1.6rem',
            textTransform: 'none',
            borderRadius: '.8rem',
            width: '100%',
            height: '4.8rem'
          }}
        >
          Ok
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default DiningTimeEndedDialog;
